export default __webpack_public_path__ + "static/media/villa_11.f46097e1.jpg";